import type { GoogleStatus } from "../types";

type Props = {
  google: GoogleStatus;
  disconnectBusy?: boolean;
  onDisconnectGoogle?: () => void;
};

export default function Topbar({ google, disconnectBusy, onDisconnectGoogle }: Props) {
  return (
    <header className="pr-top">
      <p className="text-sm font-semibold">Présence</p>
      {google.connected ? (
        <div className="flex items-center gap-2">
          <span className="pr-google-pill">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            <span className="max-w-[220px] truncate">{google.email || "Google"}</span>
          </span>
          {onDisconnectGoogle ? (
            <button type="button" className="pr-btn-ghost" disabled={disconnectBusy} onClick={onDisconnectGoogle}>
              {disconnectBusy ? "Déconnexion…" : "Déconnecter Google"}
            </button>
          ) : null}
        </div>
      ) : null}
    </header>
  );
}
